import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import type { FC } from 'react';
import { MAX_BITABLE_PAGE_SIZE } from 'src/bitable/const';
import { Icon } from 'src/common/components/icon';
import { ListItemType, ListView } from 'src/common/components/list-view';
import { useBitablePageSize } from 'src/hooks/collection-view/use-collection-view';
import { updateViewFormat } from 'src/hooks/block/use-update-collection-view';
import { useBitable } from '../../context';

interface LoadingModeProps {
  closeSelf: () => void;
}

export const LoadingMode: FC<LoadingModeProps> = ({ closeSelf }) => {
  const { viewId, isLocked } = useBitable();
  const { t } = useAppTranslation();

  const loadingModeItems = [
    {
      title: t('bitable.view.setting.scroll_loading'),
      value: 'scroll',
    },
    {
      title: t('bitable.view.setting.pagination_loading'),
      value: 'pagination',
    },
  ];

  return (
    <div className="next-modal w-36 py-2.5">
      <ListView
        items={loadingModeItems.map((item) => ({
          type: ListItemType.OPERATION,
          data: {
            title: item.title,
            value: item.value,
            onClick: () => {
              if (isLocked) return;
              updateViewFormat(viewId, {
                // @ts-ignore ignore
                loadingMode: item.value,
              });
              closeSelf();
            },
          },
        }))}
      />
    </div>
  );
};
